import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import InstantInvestmentEstimator from "./sections/InstantInvestmentEstimator";
import CuratedDigitalWorks from "./sections/CuratedDigitalWorks";
import StartYourProject from "./sections/StartYourProject";
import GetAFreeQuote from "./sections/GetAFreeQuote";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <InstantInvestmentEstimator />
      <CuratedDigitalWorks />
      <StartYourProject />
      <GetAFreeQuote />
      <Footer />
    </div>;
}